<m-select class="m-select-virtual-scroll"
          v-bind="bindData"
          v-on="$listeners"
          :virtual-scroll="true">
    <template #default="scope">
        <slot
            :props-and-handlers="scope"
        />
    </template>
    <template #outer-items="{items, getItemProps, getItemHandlers}">
        <virtual-list :size="virtualScrollItemHeight"
                      :remain="4"
                      wclass="m-base-select__virtuallist">
            <template v-for="(item, index) of items">
                <slot name="outer-item"
                      :item="item"
                      :index="index"
                      :props="getItemProps(item, index)"
                      :handlers="getItemHandlers(item, index)"
                    >
                    <m-select-item
                        v-bind="getItemProps(item, index)"
                        v-on="getItemHandlers(item, index)"
                    >
                        <slot name="item"
                              :item="item"
                              :index="index"><span v-html="item"></span></slot>
                    </m-select-item>
                </slot>
            </template>
        </virtual-list>
    </template>
</m-select>
